'use strict';

import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './appUsersWebServices';

const appUsersWebControllers = angular.module('applicationModule.appUsersWebControllers', [
    'applicationModule.appUsersWebServices',
    'ui.bootstrap',
    'ui.bootstrap.datepicker',
    'ui.select'
]);

// AppWebUsers Controllers
appUsersWebControllers.controller('AppUsersWebListController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'growl', 'AppWebUsers', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $state, $stateParams, NgTableParams, growl, AppWebUsers, AppsoupAPI, Permissions, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.writeAccess = Permissions.hasWriteAccess('users');

    $scope.user = {};
    $scope.search = {};
    $scope.groups = [];
    $scope.checkedUsers = [];
    $scope.showGroups = false;
    $scope.check = false;
    let refresh = true;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getStatusTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return AppWebUsers.getList($scope.application_id, params._params)
                .then(function (response) {
                    if (response.success) {
                        var users = response.users;
                        params.total(users.total);
                        params.count(users.per_page);
                        params.page(users.current_page);
                        return users.data;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.addGroups = function () {
        $scope.user.checkedUsers = $scope.checkedUsers;
        $scope.user.groups = [];
        if ($scope.user.checkedUsers.length !== 0) {
            $scope.showGroups = true;
        }
    };

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        AppWebUsers.searchGroups($scope.application_id, text)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    let groups = [];
                    groups = data.groups;
                    angular.forEach($scope.user.groups, function (val) {
                        angular.forEach(data.groups, function (v, k) {
                            if (val == v.id) {
                                groups.splice(k, 1);
                            }
                        });
                    });
                    $scope.groups = groups;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.GROUPS.GROWL.ERROR.' + data.error);
                }
            });
    };

    $scope.mouseLeave = function () {
        $scope.delete = '';
        $scope.edit = '';
        $scope.shopping = '';
        $scope.cart = '';
        $scope.devices = '';
        $scope.dishes = '';
        $scope.obadges = '';
        $scope.favourties = '';
    };

    $scope.mouseOverDelete = function () {
        $scope.delete = 'BUTTONS.DELETE';
    };

    $scope.mouseOverEdit = function () {
        $scope.edit = 'BUTTONS.EDIT';
    };


    $scope.cancel = function () {
        $scope.showGroups = false;
    };

    $scope.save = function () {
        $scope.user.checkedUsers = $scope.checkedUsers;
        if (angular.isDefined($scope.user.groups) && $scope.user.groups.length > 0) {
            AppWebUsers.saveGroups($scope.user)
                .then(function (result) {
                    let data = result.data;
                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.USERS.GROWL.SUCCESS.ADD_GROUPS');
                    } else if ($scope.user.checkedUsers.push()) {
                        growl.error('MODULES.APPLICATIONS.MODULES.USERS.GROWL.ERROR.EXISTS_USER');
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.USERS.GROWL.ERROR.ADD_GROUPS');
                    }
                });
        } else {
            growl.error('MODULES.APPLICATIONS.MODULES.USERS.GROWL.ERROR.EMPTY_GROUPS');
        }
        $scope.showGroups = false;
        $scope.checkedUsers = [];
    };

    $scope.removeUser = function (id, index) {
        AppWebUsers.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.DELETE_USER');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.USERS.ERROR.NO_RESOURCE');
                }
            });
    };

    $scope.removeSelectedUser = function () {
        AppWebUsers.removeSelected($scope.checkedUsers)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.DELETE_USER');
                } else {
                    growl.error('MODULES.USERS.ERROR.NO_RESOURCE');
                }
            })
            .catch(function () {
                growl.error('MODULES.USERS.ERROR.NO_RESOURCE');
            })
            .finally(function () {
                refreshData();
            });
    };

    function refreshData() {
        $scope.searchUser({refresh: refresh});
        refresh = !refresh;
        $scope.checkedUsers = [];
    }

    $scope.importQuestionnaire = function () {
        $modal.open({
            templateUrl: 'views/application/users/components/modal/questionnaire.tpl.html',
            controller: 'AppUserImportModalController',
            resolve: {
                modalData: function () {
                    return {
                        app_id: $scope.application_id
                    };
                }
            }
        });
    };

    $scope.selectUser = function (id) {
        $scope.checkedUsers = angular.selectElement($scope.checkedUsers, id);
    };

    $scope.selectAllUsers = function (item) {
        $scope.checkedUsers = angular.selectAllElements($scope.checkedUsers, item);
    };

    $scope.checkSelectedUsers = function (item) {
        return angular.checkSelectedElements($scope.checkedUsers, item);
    };

    $scope.searchUser = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.login)) {
            $scope.tableParams._params.login = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);


appUsersWebControllers.controller('AppUserWebController', ['$scope', '$rootScope', '$stateParams', '$state', 'AppWebUsers', 'growl', function ($scope, $rootScope, $stateParams, $state, AppWebUsers, growl) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    $scope.users_www_attributes = {};
    $scope.user = {
        app_id: $scope.application_id,
        status: true,
        attributes: {}
    };
    $scope.editMode = false;
    $scope.emptyTable = [];
    $scope.errors = {};
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.isRequired = true;

    function loadDefaultAttributes() {
        AppWebUsers.getAttributes($scope.application_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.users_www_attributes = data.attributes;
                angular.forEach($scope.users_www_attributes, function (attribute, key) {
                    if (!$scope.user.attributes[key] && $scope.users_www_attributes[key].default) {
                        $scope.user.attributes[key] = $scope.users_www_attributes[key].default;
                    }
                });
            }
        });
    }

    if (angular.isDefined($scope.userId)) {
        $scope.editMode = true;
        AppWebUsers.get($scope.userId, $scope.application_id).then(function (result) {
            let data = result.data;
            if (data) {
                $scope.user = data.user;
            }

        }).catch(function () {
            $state.go('appsoup.application.users_www', growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $rootScope.doingResolve = false;
            loadDefaultAttributes();
        });
    } else {
        loadDefaultAttributes();
    }


    $scope.cancel = function () {
        $state.go('appsoup.application.users_www');
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.dataForm.$valid) {
            var user = angular.copy($scope.user);
            AppWebUsers.save(user, $scope.editMode).then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.EDIT_USER');
                    $state.go('appsoup.application.users_www');
                } else {
                    $scope.formErrors = data.errors.user;
                    $scope.errors = data.errors.json_data;
                }
            });
        }
    };

    $scope.notSelectiveType = function (type) {
        return type !== 'tag' && type !== 'select' && type !== 'image' && type !== 'checkbox' && type !== 'float' && type !== 'table';
    };

    $scope.checkValid = function (name) {
        return angular.isDefinedNotNull($scope.errors[name]);
    };

    $scope.changeComma = function (data) {
        return data.replace(',', '.');
    };

    $scope.inputErrors = {
        'email': [{error: 'pattern', msg: 'USER.INVALID_FORM_EMAIL'}],
        'login': [{error: 'required', msg: 'USER.LOGIN_REQUIRED'}],
        'password': [{error: 'required', msg: 'ERROR.REQUIRE.PASS'}, {
            error: 'minlength',
            msg: 'ERROR.MIN_LENGTH.PASS',
            vars: '{ charsQty: 6 }'
        }],
        'password_verify': [
            {error: 'required', msg: 'ERROR.REQUIRE.PASS'},
            {error: 'minlength', msg: 'ERROR.MIN_LENGTH.PASS', vars: '{ charsQty: 6 }'},
            {error: 'match', msg: 'ERROR.DIFFERENT_PASS'}
        ]
    };

    $scope.$watchGroup(['user.password_verify', 'user.password'], function () {
        var isValid = !($scope.user.password !== $scope.user.password_verify && !$scope.dataForm.password_verify.$pristine);
        $scope.dataForm.password_verify.$setValidity('match', isValid);
    });
}]);

appUsersWebControllers.controller('AppUsersImportController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'AppWebUsers', function ($state, $scope, $rootScope, $stateParams, growl, AppWebUsers) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;

    $scope.requiredFields = ['"login"'];
    $scope.optionalFields = [
        '"email"',
        '"status": true/false',
        '"password"'
    ];
    $scope.ignored = 0;

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.importData = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.wrongUsers = [];
        $scope.duplicates = [];
        AppWebUsers.importData($scope.application_id, $scope.upload).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.duplicates = data.duplicates;
                $scope.ignored = data.count;
                $scope.imported = true;
                growl.success('MODULES.APPLICATIONS.MODULES.USERS_WWW.IMPORT.SUCCESS');

            } else {
                growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.users_www');
    };
}]);

export default appUsersWebControllers;